/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DocBits - API
 * DocBits - API
 * OpenAPI spec version: 11.97.2
 */
import { customAxiosInstance } from '../../mutator/custom-axios-instance';

export const getCeleryTasksManager = () => {
  /**
   * @summary Actual Queued Task Count
   */
  const actualQueuedTaskCountCeleryTasksManagerGetQueuedTasksCountGet = () => {
    return customAxiosInstance<unknown>({
      url: `/celery_tasks_manager/get_queued_tasks_count`,
      method: 'GET',
    });
  };
  /**
   * @summary Get Pending Task Ids
   */
  const getPendingTaskIdsCeleryTasksManagerGetPendingTaskIdsGet = () => {
    return customAxiosInstance<unknown>({
      url: `/celery_tasks_manager/get_pending_task_ids`,
      method: 'GET',
    });
  };
  /**
   * @summary Get Pending Tasks Count
   */
  const getPendingTasksCountCeleryTasksManagerGetPendingTasksCountPost = () => {
    return customAxiosInstance<unknown>({
      url: `/celery_tasks_manager/get_pending_tasks_count`,
      method: 'POST',
    });
  };
  return {
    actualQueuedTaskCountCeleryTasksManagerGetQueuedTasksCountGet,
    getPendingTaskIdsCeleryTasksManagerGetPendingTaskIdsGet,
    getPendingTasksCountCeleryTasksManagerGetPendingTasksCountPost,
  };
};
export type ActualQueuedTaskCountCeleryTasksManagerGetQueuedTasksCountGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getCeleryTasksManager
        >['actualQueuedTaskCountCeleryTasksManagerGetQueuedTasksCountGet']
      >
    >
  >;
export type GetPendingTaskIdsCeleryTasksManagerGetPendingTaskIdsGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getCeleryTasksManager
        >['getPendingTaskIdsCeleryTasksManagerGetPendingTaskIdsGet']
      >
    >
  >;
export type GetPendingTasksCountCeleryTasksManagerGetPendingTasksCountPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getCeleryTasksManager
        >['getPendingTasksCountCeleryTasksManagerGetPendingTasksCountPost']
      >
    >
  >;
